import React from 'react';
import { Card, Group, Skeleton, Stack } from '@mantine/core';
import { motion } from 'framer-motion';

type Props = {
    rows?: number;
    avatar?: boolean;
};

const ListSkeleton: React.FC<Props> = ({ rows = 6, avatar = true }) => (
    <Card padding={0} radius="lg" style={{ overflow: 'hidden' }}>
        <Stack gap={0}>
            {Array.from({ length: rows }).map((_, index) => (
                <motion.div
                    key={index}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.2, delay: index * 0.04 }}
                    style={{ borderTop: index ? '1px solid var(--bd-border)' : undefined }}
                >
                    <Group gap="sm" wrap="nowrap" px="md" py="sm">
                        {avatar ? <Skeleton height={34} circle /> : null}
                        <Stack gap={6} style={{ flex: 1, minWidth: 0 }}>
                            <Skeleton height={10} width={`${38 + ((index * 13) % 30)}%`} radius="sm" />
                            <Skeleton height={8} width={`${22 + ((index * 17) % 28)}%`} radius="sm" />
                        </Stack>
                        <Skeleton height={10} width={64} radius="sm" visibleFrom="sm" />
                    </Group>
                </motion.div>
            ))}
        </Stack>
    </Card>
);

export default ListSkeleton;
